import { useEffect, useState } from 'react';

/**
 * Lê um token de cor do `:root` e reage à troca de tema.
 *
 * Canvas não entende `var()`. O Chart.js pinta a borda das fatias num canvas,
 * então o valor precisa chegar resolvido — e precisa ser relido quando o tema
 * muda, senão o gráfico fica com a borda do modo anterior até o próximo
 * re-render por outro motivo.
 *
 * O observer olha o `:root` porque é lá que as duas metades do tema moram: o
 * atributo `data-theme` (claro/escuro) e o `style` inline que `applyTheme`
 * escreve (a cor escolhida). Observar só uma das duas perderia metade das
 * trocas.
 *
 * Em SVG isto não é necessário — lá `style={{ fill: 'var(--s-card)' }}`
 * resolve sozinho.
 */
export function useTokenCss(nome: string): string {
  const ler = () =>
    getComputedStyle(document.documentElement).getPropertyValue(nome).trim();

  const [valor, setValor] = useState(ler);

  useEffect(() => {
    const obs = new MutationObserver(() => setValor(ler()));
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme', 'style'],
    });
    // O tema é aplicado num efeito do App, que pode rodar depois deste.
    setValor(ler());
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nome]);

  return valor;
}
